import "./style.scss";
import { IonButton } from "@ionic/react";
import { CbhFeatureFlag, FEATURE_FLAG_DEFAULT_VALUES, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useGetShiftCancelFeedback } from "@src/appV2/Shifts/MyShiftUnavailable";
import { CancelShiftKey } from "@src/appV2/Shifts/MyShiftUnavailable/constants";
import { Shift } from "@src/appV2/Shifts/Shift/types";
import { useState } from "react";

import { AttendancePolicyCancelActionSheet } from "./attendancePolicyCancelActionSheet";

export const AttendancePolicyCancelShiftButton: React.VFC<{
  shift: Shift;
  fill?: "clear" | "outline";
}> = ({ shift, fill = "outline" }) => {
  const [showCancelActionSheet, setShowCancelActionSheet] = useState(false);
  const { isSentHomeFlowV2Enabled } = useCbhFlag(CbhFeatureFlag.SENT_HOME_REQUEST_CONFIG, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.SENT_HOME_REQUEST_CONFIG],
  });
  const shiftCancelFeedback = useGetShiftCancelFeedback(shift);

  return (
    <>
      <IonButton
        data-testid="attendance-policy-cancellation-button"
        size="large"
        expand="block"
        fill={fill}
        shape="round"
        className="attendance-policy-cancel-button"
        onClick={() => setShowCancelActionSheet(true)}
      >
        {!isSentHomeFlowV2Enabled || shiftCancelFeedback.cancelShiftKey === CancelShiftKey.CANCEL
          ? "Cancel"
          : "Cancel / Sent Home"}
      </IonButton>
      <AttendancePolicyCancelActionSheet
        showCancelActionSheet={showCancelActionSheet}
        setShowCancelActionSheet={setShowCancelActionSheet}
        shift={shift}
        isSentHomeEnabled={
          shiftCancelFeedback.cancelShiftKey === CancelShiftKey.CANCEL_OR_SENT_HOME
        }
      />
    </>
  );
};
